import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import JackpotPredictions from "@/pages/JackpotPredictions";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/jackpot-predictions")({
  head: () => ({
    meta: [
      { title: "Jackpot Predictions Today: Mega Jackpot Tips | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["jackpot"] }).meta },
      { name: "description", content: "Today's jackpot predictions for SportPesa Mega Jackpot, Betika, Bet9ja and more — data-backed picks with confidence scores for every coupon fixture." },
      { property: "og:title", content: "Jackpot Predictions Today: Mega Jackpot Tips | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Today's jackpot predictions for SportPesa Mega Jackpot, Betika, Bet9ja and more — data-backed picks with confidence scores for every coupon fixture." },
      { name: "twitter:title", content: "Jackpot Predictions Today: Mega Jackpot Tips | Statlign" },
      { name: "twitter:description", content: "Today's jackpot predictions for SportPesa Mega Jackpot, Betika, Bet9ja and more — data-backed picks with confidence scores for every coupon fixture." },
    ],
  }),
  component: () => (
    <MainLayout>
      <JackpotPredictions />
    </MainLayout>
  ),
});
